<main class="login-page" id="login-background" *ngIf="!userInApp else spinner">
  <div class="logo-container flex center-vr pointer" *ngIf="(!hideLogo && isMobile) || !isMobile">
    <a href="https://www.home365.co" target="_blank">
      <img id="logo" [src]="'./assets/img/home365_logo.svg'" alt="home 365 logo">
    </a>
  </div>
  <div id="code_container" class="flex center pointer" [ngClass]="{'codeMobile': isMobile}" *ngIf="isQa && displayCode" (click)="codeClick()">
    <h3>{{displayCode}}</h3>
  </div>
  <section class="flex center column">
    <div class="home365-card" (keydown.enter)="buttonClick()" >
      <div id="login-header" class="center-text" [ngClass]="{'dev': !isQa, 'stg': isSTG}">
        <h4 id="login-header-title">{{'LOGIN.LOGIN' | translate}}</h4>
        <p id="login-header-subtitle">{{'LOGIN.ACCESS_YOUR_ACCOUNT' | translate}}</p>
      </div>
      <ng-container *ngIf="!phoneOutherized else codeTemplate">
        <div class="form-container home365-card-body phone-no">
          <p class="red">{{failureMsg}}</p>
          <div class="select-country-header">
            <p class="light-bold">{{'LOGIN.ENTER_NUMBER' | translate}}</p>
            <p>{{'LOGIN.SELECT_COUNTRY' | translate}}</p>
          </div>
          <app-international-phone
            [defaultCountry]="CountryISO.UnitedStates"
            [label]="'Phone'"
            [type]="'login'"
            [disablePhoneValidation]="true"
            [newStyles]="true"
            [favorites]="[CountryISO.UnitedStates,CountryISO.Japan,CountryISO.Israel]"
            (phoneChanged)="onPhoneChanged($event)"
            (inputFocus)="hideLogo = $event"
            inputmode="numeric"
          ></app-international-phone>
          <mat-checkbox class="home365-checkbox" name="checkbox" [(ngModel)]="savingToLocalStorage">
            {{'LOGIN.REMEMBER_ME' | translate}}
          </mat-checkbox>
        </div>
      </ng-container>
      <div class="flex center">
        <button [disabled]="isBtnLoginValid()" #btn_loginCode (click)="buttonClick()" mat-button
                class="home365-button primary" id="action_btn">
          <span *ngIf="!loading else spinner">{{phoneOutherized ? 'Login' : 'Continue'}}</span>
        </button>
      </div>
    </div>
    <div class="user-agreement-container">
      <span class="user-agreement">{{ 'LOGIN.TERMS_OF_SERVICE_TEXT' | translate }}
        &nbsp;<a [href]="'LOGIN.TERMS_OF_SERVICE_LINK' | translate">{{'LOGIN.TERMS_OF_SERVICE_LINK_TEXT' | translate }}</a>
      </span>
      <span class="user-agreement">{{ 'LOGIN.PRIVACY_POLICY_TEXT' | translate }}
        &nbsp;<a [href]="'LOGIN.PRIVACY_POLICY_LINK' | translate">{{'LOGIN.PRIVACY_POLICY_LINK_TEXT' | translate }}</a>
      </span>
      <div class="version">{{'LOGIN.VERSION' | translate}}: {{version}}</div>
    </div>
  </section>
</main>


<div style="display: none;">
  <mat-form-field>
    <mat-label>Just For load mat-form-field</mat-label>
    <mat-select>
      <mat-option>None</mat-option>
      <mat-option value="option1"></mat-option>
    </mat-select>
  </mat-form-field>
</div>

<ng-template #spinner>
  <home365-loader [white]="true"></home365-loader>
</ng-template>

<ng-template #codeTemplate>
  <div class="form-container home365-card-body">
    <p class="card-description failureMsg">{{failureMsg}}{{internetCodeFailureMsg}}</p>
    <div>
      <div class="flex space-between" #inputCodeBox>
        <ng-container *ngFor="let index of codeDigitsArr" >

          <input type="text"
                 class="home365-code-input pointer"
                 [ngClass]="{'invalid-code':!!failureMsg}"
                 [name]="'code'+index"
                 id="{{ 'code' + index }}"
                 maxlength=1
                 pattern="[0-9]*"
                 inputmode="numeric"
                 (keyup)="validateCode($event, index)"
                 (keydown)="validateCodeDown($event, index)"
                 (paste)="validateCodeOnPaste($event)"
                 [(ngModel)]="code[index-1]"
          >
        </ng-container>
      </div>
      <div id="resend_container" class="center-text">
        <p>{{'LOGIN.ENTER_CODE' | translate}}</p>
        <p>{{'LOGIN.DIDNT_GET_IT' | translate}}</p>
        <p *ngIf="countDown !== null">{{'LOGIN.WE_CAN_RESEND' | translate}} {{countDown}}</p>
        <p *ngIf="!countDown">{{'LOGIN.RESEND_THE_CODE' | translate}}:</p>
        <div class="btn-container width-100p flex space-between center-vr">
          <span class="as-link" (click)="reSendSMS()" [ngClass]="{'disabled': !!countDown}">
            {{'LOGIN.TEXT_ME' | translate}}
          </span>
          <!-- <span home365Link (click)="reCall()" [disabled]="!!countDown">
            {{'LOGIN.CALL_ME' | translate}}
          </span> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>
